import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import {
  getHostelsList,
  deleteHostel,
} from "../../../services/OrganisationServices/hostelManagmentService";
import AddHostelComponent from "./hostel-add-compo";
import { useGlobalState } from "../../../services/hostelConst.js";

const HostelTable = () => {
  const { toggleHostelMenu } = useGlobalState();
  const { id } = useParams();
  
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();
  
  useEffect(() => {
    console.log("Hostel table component mounted");
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    toggleHostelMenu(false);

    return () => {
    };
  }, []);

  return (
    <MasterTable
      getTableData={getHostelsList}
      tab1={"Hostel"}
      tab2={"Hostel"}
      deleteRow={deleteHostel}
      AddForm={AddHostelComponent}
      actions={{
        // status: true,
        edit: true,
        delete: true,
      }}
    />
  );
};

export default HostelTable;